export interface User extends Partial<AuthTokens> {
    phone: string;
    email: string;
    first_name: string;
    last_name: string;
    gender: Gender;
    birth_date: string;
    is_registered: boolean;
    avatar: string;
    thumbnail: string;
    country: string;
    city: string;
    iban: string;
    user_type: UserType;
    emirate_government_barcode: string;
}

export interface AuthTokens {
    access: string;
    refresh: string;
}

export enum Gender {
    undefined,
    male,
    female,
    diverse,
}

export type UserType = "admin" | "seller" | "dealer" | "regular";

export interface UserStatus extends Partial<User> {
    status: Status;
}

export type Status = "REGISTERED" | "NOT_REGISTERED" | "REGISTER_NOT_COMPLETE";

export type User$ = User | null;
// export default User$;
